import LoginForm from './LoginForm';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { verifyAuth, verifyPortal, getFirstLastNameFromLocalStorage } from '../lib/common';

const Header = ({ name }) => {
  const grop = name?.group || '';
  const [user2, setUser] = useState(null);
  const [portal, setPortal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    async function GetToken() {
      const auth = await verifyAuth();
      if (auth) {
        setUser(getFirstLastNameFromLocalStorage());
        var portal = await verifyPortal();
        setPortal(portal);
      }
    }
    GetToken();
  }, []);

  useEffect(() => {
    // Add Font Awesome if not already added
    const faLink = document.querySelector('link[href*="font-awesome"]');
    if (!faLink) {
      const link = document.createElement("link");
      link.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <style>{`
        .gsp-badge {
          border: 1px solid #e5e7eb;
          background-color: white;
          padding: 0.75rem 1.25rem;
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          gap: 12px;
          min-width: 300px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          overflow: hidden;
          box-sizing: border-box;
        }
        header {
          position: sticky;
          top: 0;
          z-index: 50;
        }
      `}</style>

      {/* Top Bar */}
      <div className="bg-brand-navy text-white text-xs py-2 border-b border-white/10 z-50 relative">
        <div className="container mx-auto px-8 md:px-12 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <a href="tel:+94115422222" className="hover:text-brand-accent transition">
              <i className="fas fa-phone-alt mr-2"></i>+94 11 542 2222
            </a>
            <a href="mailto:cs@fedexlk.com" className="hover:text-brand-accent transition">
              <i className="fas fa-envelope mr-2"></i>cs@fedexlk.com
            </a>
          </div>
          <div className="hidden md:flex gap-4">
            <Link to="/career" className="hover:text-brand-accent transition">Careers</Link>
            <a href="https://newsroom.fedex.com/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent transition">News</a>
            <Link to="/contact-us" className="hover:text-brand-accent transition">Contact</Link>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-8 md:px-12 py-4 flex justify-between items-center relative">
          {/* Company Logo */}
          <div className="flex flex-col mr-12 flex-shrink-0">
            <Link to="/" className="group">
              <img 
                src="/assets/img/Advantislogo.png" 
                alt="Advantis Express Logo" 
                className="h-14 w-auto object-contain group-hover:opacity-90 transition duration-300 flex-shrink-0" 
              />
            </Link>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            <Link 
              to="/" 
              className={`font-medium transition ${
                location.pathname === '/' ? 'text-brand-navy' : 'text-gray-600 hover:text-brand-navy'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/payments" 
              className={`font-medium transition ${
                grop === 'payment' || location.pathname === '/payments' ? 'text-brand-navy' : 'text-gray-600 hover:text-brand-navy'
              }`}
            >
              Payments
            </Link>
            <Link 
              to="/shipping-rates" 
              className={`font-medium transition ${
                location.pathname === '/shipping-rates' ? 'text-brand-navy' : 'text-gray-600 hover:text-brand-navy'
              }`}
            >
              Rates
            </Link>
            <Link 
              to="/track" 
              className={`font-medium transition ${
                grop === 'track' || location.pathname === '/track' ? 'text-brand-navy' : 'text-gray-600 hover:text-brand-navy'
              }`}
            >
              Tracking
            </Link>
            <Link 
              to="/customer-support" 
              className={`font-medium transition ${
                grop === 'support' || location.pathname === '/customer-support' ? 'text-brand-navy' : 'text-gray-600 hover:text-brand-navy'
              }`}
            >
              Support
            </Link>
            {(user2 !== null && portal === true) && (
              <Link 
                to="/dashboard" 
                className="font-medium transition text-gray-600 hover:text-brand-navy"
              >
                Customer Portal
              </Link>
            )}
            
            {/* Login Form Integration */}
            <div className="ml-4">
              <LoginForm />
            </div>
            
            {/* FedEx GSP Identity Badge */}
            <div className="gsp-badge ml-4 flex items-center">
              <img
                src="/assets/img/fedex.png"
                alt="FedEx"
                className="h-[50px] w-auto flex-shrink-0"
              />
              <div className="border-l border-gray-300 h-10 mx-2 flex-shrink-0"></div>
              <div className="flex flex-col leading-tight flex-1 min-w-0 overflow-hidden">
                <span className="text-xs uppercase text-gray-600 font-semibold tracking-wide">Authorised Global</span>
                <span className="text-xs uppercase text-gray-600 font-semibold tracking-wide">Service Provider</span>
              </div>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden text-brand-navy text-2xl p-2" 
            aria-label="Toggle Menu" 
            onClick={toggleMobileMenu}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div 
          id="mobile-menu" 
          className={`${mobileMenuOpen ? '' : 'hidden'} lg:hidden bg-white border-t p-4 absolute w-full shadow-lg z-50`}
        >
          <Link to="/" className="mobile-link block py-3 border-b border-gray-100 text-gray-600 hover:text-brand-navy" onClick={closeMobileMenu}>
            Home
          </Link>
          <Link to="/payments" className="mobile-link block py-3 border-b border-gray-100 text-gray-600 hover:text-brand-navy" onClick={closeMobileMenu}>
            Payments
          </Link>
          <Link to="/shipping-rates" className="mobile-link block py-3 border-b border-gray-100 text-gray-600 hover:text-brand-navy" onClick={closeMobileMenu}>
            Rates
          </Link>
          <Link to="/track" className="mobile-link block py-3 border-b border-gray-100 text-gray-600 hover:text-brand-navy" onClick={closeMobileMenu}>
            Tracking
          </Link>
          <Link to="/customer-support" className="mobile-link block py-3 border-b border-gray-100 text-gray-600 hover:text-brand-navy" onClick={closeMobileMenu}>
            Support
          </Link>
          <Link to="/contact-us" className="mobile-link block py-3 text-gray-600 hover:text-brand-navy" onClick={closeMobileMenu}>
            Contact
          </Link>
          {(user2 !== null && portal === true) && (
            <Link to="/dashboard" className="mobile-link block py-3 border-t border-gray-100 text-gray-600 hover:text-brand-navy" onClick={closeMobileMenu}>
              Customer Portal
            </Link>
          )}
          <div className="mt-4 pt-4 border-t border-gray-200">
            <div className="mb-4">
              <LoginForm />
            </div>
            <p className="text-xs text-gray-500 mb-2">Authorized Global Service Provider for</p>
            <span className="font-bold text-brand-navy">FedEx</span>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;